"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const firebase_1 = __importDefault(require("firebase"));
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
function filenameFromFile(file) {
    const name_esc = file.name.replace(/[^.a-z0-9]/gi, '_');
    return Math.random().toString(36).substr(2, 5) + name_esc;
}
exports.filenameFromFile = filenameFromFile;
function firestoreUploadImage(file, folder = '', filename = filenameFromFile(file)) {
    const snapshot$ = new rxjs_1.Observable(subscriber => {
        var ref = firebase_1.default.storage().ref();
        if (folder)
            ref = ref.child(folder);
        ref.child(filename).put(file).then((uploadSnapshot) => {
            subscriber.next(uploadSnapshot);
            subscriber.complete();
        }, error => subscriber.error(error));
    });
    return snapshot$.pipe(operators_1.flatMap(s => rxjs_1.from(s.ref.getDownloadURL())));
}
exports.firestoreUploadImage = firestoreUploadImage;
